import {BreadCrumb, DropdownAction, MediaLightbox, CenteredModal, DropzoneFile} from "~/components";
import {Fragment, useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCopy, faDownload, faEdit, faFolder, faImage, faTrash} from "@fortawesome/free-solid-svg-icons";
import AssetsImageAPI from '~/api/assetsImageApi';
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";

const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Assets Image", to: "", isActive: true },
]

function AssetsImage(){
    const [folders, setFolders] = useState([]);
    const [files, setFiles] = useState([]);
    const [openFolders, setOpenFolders] = useState({});
    const [lightboxSrc, setLightboxSrc] = useState('');
    const [lightboxToggler, setLightboxToggler] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [reloadFile, setReloadFile] = useState(false);

    useEffect(() => {
        AssetsImageAPI.getAll()
            .then((res) => {
                setFiles(res.data);
                const folderNames = Array.from(new Set(res.data.map(item => item.FolderName)));
                setFolders(folderNames);
                const initState = {};
                folderNames.forEach((name, index) => {
                    initState[name] = index === 0;
                });
                setOpenFolders(initState);

            })
            .catch((err) => {
                ;
            })
    }, [reloadFile])

    const toggleFolder = (name) => {
        setOpenFolders(prev => ({
            ...prev,
            [name]: !prev[name]
        }));
    }

    const handleOpenLightbox = (src) => {
        setLightboxSrc(src);
        setTimeout(() => {
            setLightboxToggler(prev => !prev);
        }, 50);
    }


    const handleDownloadFile = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);

            if (!response.ok) throw new Error();

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    }

    const handleCopyLink = async (fileUrl) => {
        try {
            await navigator.clipboard.writeText(fileUrl);
        } catch (err) {
            ;
        }
    }

    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm();

    const handleEditImage = (dataFile) => {
        reset(dataFile);
        fetch(dataFile.FileUrl)
            .then((response) => response.blob())
            .then((blob) => {
                const file = new File([blob], dataFile.AssetFileName, { type: blob.type });
                const preview = URL.createObjectURL(file);
                const newFile = {
                    name: file.name,
                    size: (file.size / 1024).toFixed(2) + " KB",
                    createdDate: dataFile.CreatedDate,
                    preview,
                    file,
                };
               setSelectedFile(newFile);
               setShowEditModal(true);
            })
            .catch((err) => {
                ;
            });
    }

    const onSubmitFrom = (data) => {
        const { file, ...restData } = data;
        const formData = new FormData();
        Object.entries(restData).forEach(([key, value]) => {
            formData.append(key, value);
        });
        if (file?.[0]) {
            formData.append("file", file[0]);
        }
        AssetsImageAPI.update(formData)
            .then(res => {
                res.data?.Success ?
                    toast.success(<span className="fs-9 fw-bold">Your image has been updated.</span>)
                    : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your image.</span>)
            })
            .catch(err => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your image.</span>)
                
            })
            .finally(() => {
                setShowEditModal(false);
                setReloadFile(prev => !prev);
            })
    }

    const handleOnCloseEditModal = () => {
        setShowEditModal(false);
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-4">Assets Image</h2>
            <div className="gx-4 data-collapse-file-manager-sidebar mb-9 show-sidebar row">
                <div className="file-manager-sidebar-wrapper d-none d-lg-block col-auto">
                    <div className="file-manager-sidebar scrollbar">
                        <div className="d-flex flex-between-center">
                            <h5 className="mb-2">My Files</h5>
                        </div>
                        <ul className="mb-0 treeview">
                            <li className="treeview-list-item">
                                <div role="button" aria-expanded="true" className="treeview-collapse-item" data-discover="true">
                                    <p className="treeview-text text-nowrap">
                                        <FontAwesomeIcon icon={faFolder} className="treeview-icon"/>
                                        wwwroot
                                    </p>
                                </div>
                                <ul className="treeview-list treeview-border collapse show">
                                    {
                                        folders.map((item, index) => {
                                            const count = files.filter(x => x.FolderName.toLowerCase() === item.toLowerCase()).length;
                                            return (
                                                <li key={index} className="treeview-list-item">
                                                    <div
                                                        role="button"
                                                        aria-expanded={openFolders[item] ? "true" : "false"}
                                                        className="treeview-collapse-item"
                                                        onClick={() => toggleFolder(item)}
                                                    >
                                                        <p className="treeview-text text-nowrap">
                                                            <FontAwesomeIcon icon={faFolder} className="treeview-icon"/>
                                                            {item}
                                                            <span className="badge bg-primary ms-2">{count}</span>
                                                        </p>
                                                    </div>
                                                    <ul className={`treeview-list treeview-border collapse ${openFolders[item] ? "show" : ""}`}>
                                                        {
                                                            files.filter(x => x.FolderName.toLowerCase() === item.toLowerCase())
                                                                .map((file, idx) => (
                                                                    <li className="treeview-list-item" key={idx}>
                                                                        <div className="treeview-item">
                                                                            <div className="flex-1 ps-2 ms-2">
                                                                                <p className="treeview-text text-nowrap">
                                                                                    <FontAwesomeIcon icon={faImage} className="treeview-icon"/>
                                                                                    {file.AssetFileName}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ))
                                                        }
                                                    </ul>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="my-files col">
                    <div className="files-container">
                        {
                            files.map((file, index)  => (
                                <div key={index} className="text-center">
                                    <div className="file-box-wrapper img-zoom-hover" onDoubleClick={() => handleOpenLightbox(file.FileUrl)}>
                                        <div className="position-relative h-100">
                                            <div className="file-box overflow-hidden">
                                                <img alt="" className="w-100 h-100 object-fit-cover" src={file.FileUrl}/>
                                            </div>
                                        </div>
                                        <div className="lh-1 position-absolute top-0 end-0 mt-2 me-2 dropdown">
                                            <DropdownAction dropdownItems={[
                                                { text: "Download", icon: faDownload, onClick: () => handleDownloadFile(file.AssetFileName, file.FileUrl) },
                                                { text: "Edit", icon: faEdit, onClick: () => handleEditImage(file) },
                                                {text: "Copy link", icon: faCopy, onClick: () => handleCopyLink(file.FileUrl)}
                                            ]} isVerticalIcon={true}/>
                                        </div>
                                        <div className="d-block fw-bold text-body-highlight mt-2 text-nowrap text-truncate fs-9 fs-sm-9"
                                           data-discover="true">{file.AssetFileName}</div>
                                        <h6 className="mb-0 fw-semibold text-body-tertiary fs-10 fs-sm-10">{file.SizeReadable}</h6>
                                    </div>
                                </div>
                            ))
                        }
                        <MediaLightbox src={lightboxSrc} toggler={lightboxToggler} />
                    </div>
                </div>
            </div>
            <CenteredModal show={showEditModal}
                           onClose={handleOnCloseEditModal}
                           title="Edit Assets Image"
                           formId="formEdit"
            >
                <form id="formEdit" onSubmit={handleSubmit(onSubmitFrom)}>
                    <div className="mb-3">
                        {
                            selectedFile && (
                                <Fragment>
                                    <div className="row">
                                        <label className="col-form-label col-sm-3 fs-8-1">Image name:</label>
                                        <div className="col-sm-9 col-form-label">
                                            <span className="fs-9 fw-semibold">{selectedFile.name}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label className="col-form-label col-sm-3 fs-8-1">Image size:</label>
                                        <div className="col-sm-9 col-form-label">
                                            <span className="fs-9 fw-semibold">{selectedFile.size}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label className="col-form-label col-sm-3 fs-8-1">Upload date:</label>
                                        <div className="col-sm-9 col-form-label">
                                            <span className="fs-9 fw-semibold">{selectedFile.createdDate}</span>
                                        </div>
                                    </div>
                                </Fragment>
                            )
                        }
                        <div className="mt-3">
                            <DropzoneFile
                                label="Assign Image(*)"
                                register={register}
                                name="file"
                                errors={errors}
                                selectedFile={selectedFile}
                                setSelectedFile={setSelectedFile}
                                requiredMessage = "File is required."
                            />
                        </div>
                    </div>
                </form>
            </CenteredModal>
        </Fragment>
    )
}

export default AssetsImage;
